/**
 * Aynı gün teslimat sayacı.
 *
 * Kesim saatine kalan süreyi dakika başı günceller. Saat İstanbul'a göre okunur, böylece
 * müşterinin cihaz saati farklı olsa bile mağazanın saati esas alınır. Kesim saati sepetteki
 * teslimat seçicisiyle aynı tema ayarından gelir.
 */
function cartCountdownIstanbulNow() {
  const p = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Istanbul',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  })
    .formatToParts(new Date())
    .reduce((a, x) => {
      a[x.type] = x.value;
      return a;
    }, {});
  return { hour: Number(p.hour), minute: Number(p.minute), second: Number(p.second) };
}

function cartCountdownSure(kalanDakika) {
  const saat = Math.floor(kalanDakika / 60);
  const dakika = kalanDakika % 60;
  if (saat > 0 && dakika > 0) return `${saat} saat ${dakika} dakika`;
  if (saat > 0) return `${saat} saat`;
  return `${dakika} dakika`;
}

function cartCountdownGuncelle(kok) {
  const metin = kok.querySelector('[data-cart-countdown-text]');
  if (!metin) return;

  const cutoff = Number(kok.dataset.cutoffHour || 16);
  const now = cartCountdownIstanbulNow();
  const kalanDakika = (cutoff - now.hour) * 60 - now.minute;

  if (kalanDakika <= 0) {
    metin.textContent = kok.dataset.after || '';
    kok.dataset.state = 'closed';
  } else {
    metin.textContent = (kok.dataset.before || '').replace('{{ kalan }}', cartCountdownSure(kalanDakika));
    kok.dataset.state = 'open';
  }
  kok.hidden = false;
}

function cartCountdownBaslat() {
  const kokler = document.querySelectorAll('[data-cart-countdown]');
  if (!kokler.length) return;
  kokler.forEach(cartCountdownGuncelle);
}

cartCountdownBaslat();
document.addEventListener('DOMContentLoaded', cartCountdownBaslat);
// Tema düzenleyicide bölüm yeniden yüklenirse.
document.addEventListener('shopify:section:load', cartCountdownBaslat);

/* Sepet değişince (adet, silme, öneri ekleme) bölüm innerHTML ile yeniden basılıyor ve
   yeni gelen sayaç kutusu boş geliyor. Aşağıdaki dakikalık zamanlayıcı onu er geç
   dolduruyordu ama arada bir dakikaya kadar boş bir kutu görünüyordu. */
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, cartCountdownBaslat);
}

setInterval(cartCountdownBaslat, 60000);

/* Kart rozeti "Bugün teslim": rozet sunucuda Liquid 'now' ile basılıyor ve Shopify sayfayı
   önbellekten verebiliyor; kesimden önce oluşmuş bir sayfa kesimden sonra da rozeti
   gösterebilir. Burada İstanbul saati kesimi geçtiyse rozetler gizlenir. Açılış
   sayfasında rozetle birlikte basılan yedek teslimat metni (data-fg-delivery-fallback)
   aynı anda görünür olur. Kesim saati, her sayfada bulunan teslimat penceresinin
   data-cutoff-hour değerinden okunur (tema ayarı delivery_cutoff_hour). */
function todayBadgeKesimGecti() {
  const kaynak = document.querySelector('[data-cutoff-hour]');
  const cutoff = Number((kaynak && kaynak.dataset.cutoffHour) || 16);
  return cartCountdownIstanbulNow().hour >= cutoff;
}

function todayBadgeGuncelle() {
  if (!todayBadgeKesimGecti()) return;
  document.querySelectorAll('.ds-r-today-badge:not([hidden])').forEach((rozet) => {
    rozet.hidden = true;
  });
  document.querySelectorAll('[data-fg-delivery-fallback][hidden]').forEach((yedek) => {
    yedek.hidden = false;
  });
}

todayBadgeGuncelle();
document.addEventListener('DOMContentLoaded', todayBadgeGuncelle);
document.addEventListener('shopify:section:load', todayBadgeGuncelle);
setInterval(todayBadgeGuncelle, 60000);

/* Filtre, sıralama ve sayfalama ürün ızgarasını yeniden basar; yeni kartlar da
   kontrol edilsin. Kesim öncesinde hiçbir şey yapmaz. */
if ('MutationObserver' in window) {
  let todayBadgeBekleyen = false;
  new MutationObserver(() => {
    if (todayBadgeBekleyen) return;
    todayBadgeBekleyen = true;
    requestAnimationFrame(() => {
      todayBadgeBekleyen = false;
      todayBadgeGuncelle();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
}
